import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false); // State to toggle mobile menu
const [resourcesOpen, setResourcesOpen] = useState(false);
const resourcesRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (resourcesRef.current && !resourcesRef.current.contains(event.target)) {
        setResourcesOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  // Helper function to determine if a link is active
  const isActive = (path) =>
    location.pathname === path ? "text-yellow-500 font-semibold" : "hover:text-yellow-500";

  return (
	  <>
	     <nav className="relative flex justify-between items-center px-5 md:px-0 py-6 z-10 mx-auto container text-sm font-medium">
      <div className="w-28">
        <Link to="/">
          <img src="/seotic-logo.png" alt="Seotic Logo" />
        </Link>
      </div>

      {/* Desktop Navigation */}
      <div className="space-x-10 hidden md:flex uppercase items-center">
      <a href="/" className={isActive("/")}>Home</a>
        <a href="/features" className={isActive("/features")}>Features</a>
        <a href="/webaudit" className={isActive("/webaudit")}>Free Audit</a>
        <a href="/pricing" className={isActive("/pricing")}>Pricing</a>
          <a href="/about" className={isActive("/about")}>About Us</a>
        <div className="relative" ref={resourcesRef}>
                  <button
          onClick={() => setResourcesOpen((prev) => !prev)}
            className={`flex uppercase items-center ${resourcesOpen ? "text-yellow-500" : "hover:text-yellow-500"}`}
          >
            Resources<i className='bx bx-chevron-down ml-1'></i>
          </button>
          {resourcesOpen && (
            <div className="absolute left-1/2 -translate-x-1/2 mt-6 shadow-lg w-[650px] bg-white rounded-lg p-5 grid grid-cols-2 gap-2 normal-case text-gray-700 border border-slate-200">
              <Link
                to="/blog"
                className="flex items-start space-x-4 p-5 rounded-lg hover:bg-gray-50"
              >
                <i className="bx bx-news text-2xl text-yellow-500"></i>
                <div>
                  <h4 className="font-semibold uppercase text-gray-900">Blog</h4>
                  <p className="text-sm text-gray-500 font-normal">Latest insights and updates.</p>
                </div>
              </Link>
              <Link
                to="/changelog"
                className="flex items-start space-x-4 p-5 rounded-lg hover:bg-gray-50"
              >
                <i className="bx bx-bolt-circle text-2xl text-yellow-500"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 uppercase">What's New</h4>
                  <p className="text-sm text-gray-500 font-normal">Product changes and releases.</p>
                </div>
              </Link>
              <Link
                to="/help"
                className="flex items-start space-x-4 p-5 rounded-lg hover:bg-gray-50"
              >
                <i className="bx bx-help-circle text-2xl text-yellow-500"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 uppercase">Help Center</h4>
                  <p className="text-sm text-gray-500 font-normal">Find answers and support.</p>
                </div>
              </Link>
              <a
                href="most-visited"
                className="flex items-start space-x-4 p-5 rounded-lg hover:bg-gray-50"
              >
                <i className="bx bx-globe text-2xl text-yellow-500"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 uppercase">Top Websites</h4>
                  <p className="text-sm text-gray-500 font-normal">Discover leading sites.</p>
                </div>
              </a>
              <Link
                to="/glossary"
                className="flex items-start space-x-4 p-5 rounded-lg hover:bg-gray-50"
              >
                <i className="bx bx-book text-2xl text-yellow-500"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 uppercase">SEO Glossary</h4>
                  <p className="text-sm text-gray-500 font-normal">Key SEO terms explained.</p>
                </div>
              </Link>
              <a
                href="https://rapidapi.com/zaw-Sp-4cO-9c/api/website-audit2"
                target="_blank"
                rel="noreferrer"
                className="flex items-start space-x-4 p-5 rounded-lg hover:bg-gray-50"
              >
                <i className="bx bx-analyse text-2xl text-yellow-500"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 uppercase">Website Audit API <i class='bx bx-link-external bx-fw bx-xs'></i></h4>
                  <p className="text-sm text-gray-500 font-normal">Automate site checks.</p>
                </div>
              </a>
              <a
                href="https://chromewebstore.google.com/detail/seotic-auditor/nlaeelmhegilipppplelpkpopjinbkfe?authuser=1&hl=en-GB"
                target="_blank"
                rel="noreferrer"
                className="flex items-start space-x-4 p-5 rounded-lg hover:bg-gray-50"
              >
                <i className="bx bx-window-alt text-2xl text-yellow-500"></i>
                <div>
                  <h4 className="font-semibold text-gray-900 uppercase">Chrome Extension <i class='bx bx-link-external bx-fw bx-xs'></i></h4>
                  <p className="text-sm text-gray-500 font-normal">Instant on-page SEO audit.</p>
                </div>
              </a>
               <a
                href="https://chatgpt.com/g/g-68b20bfc78a48191b5aca27feb98787c-seochan"
                target="_blank"
                rel="noreferrer"
                className="flex items-start space-x-4 p-5 rounded-lg hover:bg-gray-50"
              >
                <img className="w-7" src="https://www.seotic.co/static/media/SeoChanProfile.1349b2a7fe1781f93bff.png" />
                <div>
                  <h4 className="font-semibold text-gray-900 uppercase">SeoChan GPT <i class='bx bx-link-external bx-fw bx-xs'></i></h4>
                  <p className="text-sm text-gray-500 font-normal">Ask me about SEO related.</p>
                </div>
              </a>

                         </div>
          )}
        </div>

        
       
       
      </div>

      <div className="space-x-10 hidden md:flex uppercase items-center">
        <a
          href="https://app.seotic.co/login"
          target="_blank"
          title="login"
          className="text-right hover:text-blue-600"
        >
          Login
        </a>
        <a
          href="https://app.seotic.co/register"
          target="_blank"
          title="register"
          data-seotic-event="click:signup_cta"
          className="px-5 py-2 bg-yellow-300 text-yellow-900 rounded-lg hover:bg-yellow-400 hidden md:block"
        >
          Free Register
        </a>
      </div>

      {/* Hamburger Icon for Mobile */}
      <div className="md:hidden">
        <button onClick={() => setMenuOpen(!menuOpen)} className="text-gray-700 focus:outline-none">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="fixed inset-0 bg-black  z-20">
          <div className="flex flex-col items-center justify-center h-full space-y-8 text-white uppercase text-lg font-medium">
            <a href="/features" className={isActive("/features")} onClick={() => setMenuOpen(false)}>Features</a>
            <a href="/webaudit" className={isActive("/webaudit")} onClick={() => setMenuOpen(false)}>Free Audit</a>
             <a href="/pricing" className={isActive("/pricing")} onClick={() => setMenuOpen(false)}>Pricing</a>
              <a href="/about" className={isActive("/about")} onClick={() => setMenuOpen(false)}>About us</a>
            <Link to="/blog" className={isActive("/blog")} onClick={() => setMenuOpen(false)}>Blog</Link>
           
          
           
            <a href="https://app.seotic.co/login" target="_blank" title="login" className="hover:text-blue-600" onClick={() => setMenuOpen(false)}>Login</a>
            <a href="https://app.seotic.co/register" target="_blank" title="register" className="px-5 py-2 bg-yellow-300 text-yellow-900 rounded-lg hover:bg-yellow-400" onClick={() => setMenuOpen(false)}>Free Register</a>
          </div>
          {/* Close button for mobile menu */}
          <button className="absolute top-5 right-5 text-white" onClick={() => setMenuOpen(false)}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      )}
    </nav>
    </>
  );
}

export default Navbar;
